import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';

@Component({
  selector: 'app-note-modal',
  templateUrl: './note-modal.component.html',
  styleUrls: ['./note-modal.component.scss']
})
export class NoteModalComponent implements OnInit {
  note = false;
  noteText = '';
  label: string;
  formNote = this.fb.group({
    note: [null, Validators.required],
    priority: [null, Validators.required],
    status: [null, Validators.required],
  });
  id;
  callId: string;
  type: string;
  customerId: string;
  @Output() newData = new EventEmitter();
  constructor(
    private fb: FormBuilder
  ) { }

  ngOnInit() {
  }
  showNote(data, type: string) {
    this.type = type;
    this.formNote.reset();
    this.callId = undefined;
    this.customerId = data.customerId  !== undefined ? data.customerId : null;
    this.note = true;
    if (type === 'update') {
      this.label = 'Cập nhật ghi chú';
      this.id = data.id;
      this.formNote.controls.note.setValue(data.note);
      this.noteText =     this.formNote.controls.note.value
      this.formNote.controls.priority.setValue(data.priority);
      this.formNote.controls.status.setValue(data.status);
      return;
    }
    this.label = 'Tạo mới ghi chú';
    this.callId = data;
  }
  hideNote() {
    this.note = false;
  }
  submit() {
    // tslint:disable-next-line:forin
    for (const i in this.formNote.controls) {
      this.formNote.controls[i].markAsDirty();
      this.formNote.controls[i].updateValueAndValidity();
    }
    if (this.formNote.invalid) {
      return;
    }
    this.newData.emit({id: this.id, value: this.formNote.value, callId: this.callId, customerId: this.customerId, type: this.type});
  }
}
